export enum PaceTaskTabScreens {
  Project = 'project',
  Engineering = 'engineering',
  Leasing = 'leasing',
  Permitting = 'permitting',
  ProjectManagement = 'project-management',
  Forecasting = 'forecasting',
}
